import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Newsletter from "../layout/Newsletter";
import Sponsors from "../layout/Sponsors";
import { imageUrlFor } from "../../utils/image-url";
import HostedByNetlife from "../layout/HostedByNetlife";

const logo = "/icons/icon-512x512.png";

const mainWrapperClasses = hamburgerOpen =>
  classNames({
    "flex flex-col justify-between overflow-x-hidden min-h-screen px-5vw sm:px-7-5vw py-4vw z-50": true,
    "bg-black text-white": hamburgerOpen,
  });

const contentWrapperClasses = hamburgerOpen =>
  classNames({
    "mt-6 flex-grow": true,
    "sr-only": hamburgerOpen,
  });

const Layout = ({
  children,
  toggleHamburger,
  hamburgerOpen,
  breadcrumb,
  hideHamburger,
  currentPage,
  metaInfo,
  pageSchemas,
}) => {
  return (
    <div>
      <Helmet>
        <title>
          {metaInfo?.title ? `${metaInfo?.title} – Y Oslo` : "Y Oslo"}
        </title>
        <meta
          property="og:title"
          content={metaInfo?.someTitle || metaInfo?.title || "Y Oslo"}
        />
        <meta
          name="twitter:title"
          content={metaInfo?.someTitle || metaInfo?.title || "Y Oslo"}
        />

        <meta
          name="description"
          content={
            metaInfo?.description ??
            "Y is a conference where you learn to make better products and services — for people and for the planet."
          }
        />
        <meta
          property="og:description"
          content={
            metaInfo?.description ??
            "Y is a conference where you learn to make better products and services — for people and for the planet."
          }
        />
        <meta
          name="twitter:description"
          content={
            metaInfo?.description ??
            "Y is a conference where you learn to make better products and services — for people and for the planet."
          }
        />

        {metaInfo?.video && (
          <meta property="og:video" content={metaInfo?.video ?? ""} />
        )}

        <meta
          property="og:image"
          content={metaInfo?.image ? imageUrlFor(metaInfo?.image).url() : logo}
        />
        <meta property="og:image:alt" content={metaInfo?.imageAlt ?? ""} />
        <meta
          name="twitter:image"
          content={metaInfo?.image ? imageUrlFor(metaInfo?.image).url() : logo}
        />
        <meta name="twitter:image:alt" content={metaInfo?.imageAlt ?? ""} />

        <link
          rel="canonical"
          href={`https://www.y-oslo.com/${metaInfo?.fullSlug ?? ""}`}
        />
        <meta
          property="og:url"
          content={`https://www.y-oslo.com/${metaInfo?.fullSlug ?? ""}`}
        />
        <meta property="og:type" content={metaInfo?.type ?? "website"} />
        <meta property="og:fb:page_id" content="Y.Oslo.Intervention" />
        <meta name="twitter:site" content="@Y_Oslo" />
        <meta
          name="twitter:card"
          content={metaInfo?.image ? "summary_large_image" : "summary"}
        />
        {pageSchemas && (
          <script type="application/ld+json">
            {JSON.stringify(pageSchemas)}
          </script>
        )}
        <script
          dangerouslySetInnerHTML={{
            __html: `
          !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
          n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
          document,'script','https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '612736219189580');
          fbq('track', 'PageView');
        `,
          }}
        />

        <noscript>
          {`<img
          height="1"
          width="1"
          style="display:none"
          src="https://www.facebook.com/tr?id=612736219189580&ev=PageView&noscript=1"
        />`}
        </noscript>
      </Helmet>

      <div className={mainWrapperClasses(hamburgerOpen)}>
        {!hamburgerOpen && (
          <a href="#main" className="sr-only focus:not-sr-only">
            Skip to main content
          </a>
        )}

        <Header
          toggleHamburger={toggleHamburger}
          breadcrumb={breadcrumb}
          hideHamburger={hideHamburger}
          hamburgerOpen={hamburgerOpen}
          currentPage={currentPage}
        />

        <main
          id="main"
          className={contentWrapperClasses(hamburgerOpen)}
          hidden={hamburgerOpen}
        >
          {children}
          <Newsletter></Newsletter>
          <Sponsors></Sponsors>
          <Footer dark={hamburgerOpen} />
        </main>
      </div>

      {!hamburgerOpen && <HostedByNetlife />}
      
    </div>
  );
};

Layout.propTypes = {
  hamburgerOpen: PropTypes.bool,
  hideHamburger: PropTypes.bool,
  toggleHamburger: PropTypes.func,
  breadcrumb: PropTypes.object,
  currentPage: PropTypes.string,
};

export default Layout;
